module.exports = __webpack_public_path__ + "img/1510470909.bf4235ba.jpg";